<template lang="pug">
    div
        v-card
            v-layout(row wrap)
                v-flex(md8)
                    v-text-field.mx-3.pl-5.pr-5.pt-4(
                                v-model="employeeFullName" 
                                readOnly
                            )
                                div.formLabel2(slot="prepend")
                                    | Empleado
                v-flex(md2)
                    v-btn.mt-4(block color="info" outline) Limpiar Formulario
                v-flex.pl-5.pr-5(md12)
                    crud-form.pl-5.pt-3(
                        
                        :fields="fieldsIndemnizationContractual" 
                        noButtons 
                        @submitForm="indemnizationFormSubmit" 
                        ref="indemnizationContractualForm"
                        formTitle="Indemnización contractual"
                        noPadding
                        )
                v-flex.pl-5.pr-5(md12)
                    crud-form.pl-5.pt-3(
                        
                        :fields="fieldsProportionalHoliday" 
                        noButtons 
                        @submitForm="ProportionalHolidaySubmit" 
                        ref="ProportionalHolidayForm"
                        formTitle="Feriado Proporcional"
                        noPadding
                    )
                v-flex.pl-5.pr-5(md12)
                    v-btn( 
                        block 
                        color="success" 
                        @click="validateForm"
                        )
                        | GENERAR
                        

</template>

<script>
/* components */
import { CrudForm } from '@/components/reusable_components/'
/* fields */
import fieldsIndemnizationContractual from './fieldsIndemnizationContractual'
import fieldsProportionalHoliday from './fieldsProportionalHoliday'
/* services */
import EmployeeService from '@/services/api/employee'
import HrCausalService from '@/services/api/hrCausal'
import FiniquitoService from '@/services/api/finiquito'
/* vuex */
import { mapActions } from 'vuex'

export default {
    name: 'finiquito-comp',
    props: {
        dataPrecedent: {
            type: Object,
            required: true,
        },
    },
    data: function() {
        return {
            fieldsIndemnizationContractual: fieldsIndemnizationContractual,
            fieldsProportionalHoliday: fieldsProportionalHoliday,
            employeeFullName: '',
            agreed_compensation_days: null,
            freedays_proportional_days: null,
            freedays_proportional_festive_days: null,
        }
    },
    // computed: {},
    methods: {
        // -- UI Modification
        // -- Data fetching
        // -- Data handling and transformations
        indemnizationFormSubmit(event) {
            this.setAgreedCompensationDays(event.agreed_compensation_days)
        },
        /**
         *
         */
        setAgreedCompensationDays(days) {
            this.agreed_compensation_days = days
        },
        /**
         *
         */
        ProportionalHolidaySubmit(event) {
            this.setFreeDaysProportional(event.freedays_proportional_days)
            this.setFreedaysProportionalFestiveDays(
                event.freedays_proportional_festive_days
            )
        },
        setFreeDaysProportional(days) {
            this.freedays_proportional_days = days
        },
        /**
         *
         */
        setFreedaysProportionalFestiveDays(days) {
            this.freedays_proportional_festive_days = days
        },
        // -- Validations and Error handling
        /**
         *
         */
        async validateForm() {
            this.$refs.indemnizationContractualForm.submitForm()
            this.$refs.ProportionalHolidayForm.submitForm()
            if (this.checkValidatedAllForm()) {
                let response = await FiniquitoService.createFiniquito(
                    this.setDataForSubmit()
                )
                this.snackResponseSubmit(response)
            }
        },
        /**
         *
         */
        checkValidatedAllForm() {
            if (!this.agreed_compensation_days) return false
            if (!this.freedays_proportional_days) return false
            if (!this.freedays_proportional_festive_days) return false
            return true
        },
        setEmployeeFullName(finiquito) {
            this.employeeFullName = finiquito.full_name_employee
        },
        /**
         *
         */
        setDataForSubmit() {
            let submitData = { ...this.dataPrecedent }
            submitData.agreed_compensation_days = this.agreed_compensation_days
            submitData.freedays_proportional_days = this.freedays_proportional_days
            submitData.freedays_proportional_festive_days = this.freedays_proportional_festive_days
            return submitData
        },
        /**
         *
         */
        snackResponseSubmit(response) {
            if (response.status === 'success') {
                const msg = 'Finiquito creado exitosamente'
                this.successMessage(msg)
                this.redirectTo('/finiquitos')
            } else this.errorMessage(response)
        },
        /**
         *
         */
        successMessage(message) {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack('success', 'Éxito', message, false, 5000)
            )
        },
        /**
         *
         */
        errorMessage(response) {
            this.resetSnackbarState()
            if (response.error)
                this.initSnackbar(
                    this.fillSnack(
                        'error',
                        'Error',
                        response.error,
                        false,
                        5000
                    )
                )
            else
                this.initSnackbar(
                    this.fillSnack(
                        'error',
                        'Error',
                        'Ha ocurrido un error al enviar los datos al servidor',
                        false,
                        5000
                    )
                )
        },
        /**
         *
         */
        redirectTo(route) {
            this.$router.push(route)
        },
        cleanForms() {
            this.$refs.indemnizationContractualForm.$refs.form.reset
        },
        // -- Other functions
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        dataPrecedent(val) {
            this.setEmployeeFullName(val)
        },
    },
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    mounted() {
        this.cleanForms()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_FINIQUITO')) ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
.myFormAdjust {
    margin-top: -64px;
}
.formLabel2 {
    font-weight: bold;
    min-width: 150px;
    max-width: 150px;
    font-size: 30px;
}
</style>